import { render } from "./404.vue?vue&type=template&id=5cda2639&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=5cda2639&scoped=true&lang=scss"

import exportComponent from "/var/www/forlove.elena-dating.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cda2639"]])

export default __exports__